import React from 'react';
import { motion } from 'framer-motion';
import { assets } from '../lib/assets';

const pillars = [
  { title: 'Lifelong connection', copy: 'A tree outlives flowers, watches, and words. It grows with them.' },
  { title: 'Quiet sustainability', copy: 'Every tree deepens our orchard, cleans the air, and feeds a family.' },
  { title: 'Emotional gifting', copy: 'Not bought in a mall. Chosen from the earth, for someone who matters.' },
  { title: 'Living memory', copy: 'A name plaque. A patch of soil. A return address, forever.' },
];

export default function WhySpecial() {
  return (
    <section className="relative bg-brand-bg2 py-28 md:py-36" data-testid="why-special-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="md:col-span-5"
        >
          <div className="relative rounded-3xl overflow-hidden aspect-[3/4]">
            <img src={assets.plaque} alt="Wooden plaque on tree trunk" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/35 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-brand-bg">
              <div className="font-serif italic text-brand-gold text-sm mb-1">Dedication plaque</div>
              <div className="font-serif text-2xl leading-tight">For Amma, with all our seasons.</div>
            </div>
          </div>
        </motion.div>

        <div className="md:col-span-7">
          <p className="text-brand-gold tracking-[0.25em] uppercase text-xs mb-5 font-medium">Why this matters</p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="font-serif text-4xl sm:text-5xl lg:text-[56px] text-brand-ink leading-[1.05] tracking-tight font-light"
          >
            You don't just plant a tree.<br />
            <span className="italic text-brand-forest">You plant a story.</span>
          </motion.h2>

          <p className="mt-7 text-brand-ink2 text-lg max-w-xl leading-relaxed">
            Somewhere in Kalwan Taluka, near Nashik, a sapling will learn its first name in the wind —
            and carry it through two decades of harvests.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            {pillars.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                className="border-l-2 border-brand-gold/60 pl-5 py-1"
                data-testid={`why-pillar-${i}`}
              >
                <div className="font-serif text-xl text-brand-ink mb-1.5 font-medium">{p.title}</div>
                <div className="text-brand-ink2 text-[15px] leading-relaxed">{p.copy}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
